import { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import { getUnreadCounts } from './adminApi';

const NotificationContext = createContext({ messages: 0, dreams: 0, refresh: () => {} });

export function NotificationProvider({ children }) {
  const [counts, setCounts] = useState({ messages: 0, dreams: 0 });
  const intervalRef = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const data = await getUnreadCounts();
      setCounts({ messages: data.messages ?? 0, dreams: data.dreams ?? 0 });
    } catch {
      // silently ignore — auth redirect handled in adminFetch
    }
  }, []);

  useEffect(() => {
    refresh();
    intervalRef.current = setInterval(refresh, 30_000);
    return () => clearInterval(intervalRef.current);
  }, [refresh]);

  return (
    <NotificationContext.Provider value={{ ...counts, refresh }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
